<template>
  <div class="room-service">
    <i
      role="tooltip"
      tabindex="0"
      :class="`rhg-font-icon--${service.code} sm tooltip-dynamic`"
      data-toggle="tooltip"
      :title="service.name"
      :data-original-title="service.name"
      :aria-label="service.code"
    ></i>
    <div class="room-service__separator"></div>
  </div>
</template>

<script>
import RoomService from '../../domain/RoomService'

export default {
  name: 'RoomCardServices',
  components: {},
  props: {
    service: {
      type: RoomService
    }
  },
  created() {
    this.$nextTick(() => {
      global.UtilsLayout.tooltip()
    })
  }
}
</script>

<style lang="scss" scoped>
.room-service {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 40px;
  margin-right: 15px;

  &__separator {
    border-right: solid 1px #53565a;
    height: 20px;
  }

  @media (max-width: 992px) {
    display: none;
  }
}
.room-service:nth-child(4) > .room-service__separator {
  border-right: none;
}
</style>
